module.exports = {
      id: "27a64ab563e9eca9e847196201b0a8b7construction-skeleton.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#27a64ab563e9eca9e847196201b0a8b7construction-skeleton.svg",
      toString: function () {
        return this.url;
      }
    }